<template>
  <narrow-container>
    <div
      id="loading"
      :class="{'show':inProgress}"
    />
    <h1 class="headline-secondary text--center">
      {{ this.$i18n.t('KUZO_REGISTRATION.HEADER') }}
    </h1>
    <input-box
      id="loginKuzoRegistration"
      ref="loginField"
      :label="this.$i18n.t('KUZO_REGISTRATION.LOGIN_NUMBER')"
      name="loginField"
      :disabled="true"
    />
    <br>
    <p>
      {{ this.$i18n.t('KUZO_REGISTRATION.EMAIL_INFO') }}
    </p>
    <validated-input-box
      id="emailField"
      ref="emailField"
      :validation-reg-exp="emailRegex"
      :validation-error-message="$i18n.t('COMMON.ERROR_MESSAGES.EMAIL_ERROR')"
      :label="this.$i18n.t('KUZO_REGISTRATION.EMAIL')"
      autocomplete="customer-email-address"
      name="emailField"
    />
    <p>
      <strong>{{ this.$i18n.t('KUZO_REGISTRATION.NOTE') }}</strong>
      {{ this.$i18n.t('KUZO_REGISTRATION.PASSWORD_INFO') }}
    </p>
    <selfcare-password-input
      id="newPasswordField"
      ref="newPasswordField"
      name="newPasswordField"
      :label1="this.$i18n.t('KUZO_REGISTRATION.PASSWORD')"
      :label2="this.$i18n.t('KUZO_REGISTRATION.CONFIRM_PASSWORD')"
      :mandatory="true"
    />
    <br>
    <validated-input-box
      v-if="isVoucherAllowed"
      id="voucherField"
      ref="voucherField"
      :label="this.$i18n.t('KUZO_REGISTRATION.VOUCHER')"
      name="voucherField"
      :remove-whitespaces="true"
      validation-reg-exp="^[a-zA-Z0-9]{16}$"
      autocomplete="activation-voucher"
      :validation-error-message="this.$i18n.t('KUZO_REGISTRATION.ERROR_MESSAGES.VOUCHER_INVALID')"
    />

    <checkbox
      id="dreiFlag"
      ref="dreiFlag"
      name="dreiFlag"
      :initial-value="existingCustomer"
    >
      {{ this.$i18n.t('KUZO_REGISTRATION.CHECKBOX1') }}
    </checkbox>
    <checkbox
      id="marketingFlag"
      ref="marketingFlag"
      name="marketingFlag"
      :initial-value="marketing"
    >
      {{ this.$i18n.t('KUZO_REGISTRATION.CHECKBOX2') }}
    </checkbox>
    <submit-button
      id="kuzoRegistrationSubmitButton"
      :label="this.$i18n.t('KUZO_REGISTRATION.FINISH')"
      :on-click="submitForm"
    />
  </narrow-container>
</template>

<script>
import Regex from '@/constants/regex.json';

const VALIDATION_ERROR = 1;
const TEMPORARILY_LOCKED =2;
const PUK_INCORRECT = 3;
const ACTIVATION_NOT_POSSIBLE = 4;
const SIM_INACTIVE = 5;
const VOUCHER_NOT_USEABLE = 8;
const VOUCHER_USE_LOCKED = 9;
const OTHER_ERROR = 9999;

export default {
  name: 'KuzoRegistration',
  components: {  },
  data: function() {
    return {
      inProgress: false,
      passwordsMatch: true,
      existingCustomer: false,
      marketing: false,
      activationToken: null,
      activationRequest: null,
      isMounted: false,
    };
  },
  computed: {
    emailRegex: function() {
      return Regex.EMAIL;
    },
    isVoucherAllowed: function() {
      return this.$store.getters.voucherAllowed;
    }
  },
  mounted: function() {
    this.activationToken = this.$store.getters.activationToken;
    if(!this.activationToken) {
      this.$router.push({name: 'activation'});
    } else {
      this.$refs.loginField.setFieldValue(this.activationToken.msisdn);
      this.isMounted = true;
    }
  },
  methods: {
    isFormValid: function() {
      const isValid =
        this.$refs.emailField.isValidBeforeSubmit()
        && this.$refs.newPasswordField.isValidBeforeSubmit();
      return isValid;
    },
    submitForm: function() {
      if (!this.inProgress && this.isFormValid()) {
        this.inProgress = true;
        this.activationRequest = {
          msisdn: this.activationToken.msisdn,
          puk: this.activationToken.puk,
          email: this.$refs.emailField.getFieldValue(),
          password: this.$refs.newPasswordField.getFieldValue(),
          marketingFlag: this.$refs.marketingFlag.getValue()?"Y":"N",
          existingCustomerFlag: this.$refs.dreiFlag.getValue()?"Y":"N"
        };

        if(this.isVoucherAllowed) {
          this.activationRequest.voucher = this.$refs.voucherField.getFieldValue()
        }

        this.$http.post('api/dreitvkarte/activate', this.activationRequest)
          .then( (response) => {
            this.processSuccessfulCallResponse(response);
          })
          .catch(callData => {
            this.processErrorCallResponse(callData);
          })
          .finally(() => {
            this.inProgress = false;
          })
      }
    },
    processSuccessfulCallResponse: function(response) {
      this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'KUZO registration',label: 'Success', value: 0, noninteraction: false });
      this.$store.commit('setSuccessMessage', this.$i18n.t('KUZO_REGISTRATION.SUCCESS'));
      this.$store.commit("clearActivationToken");
      this.$store.commit("setLoginCredentials",  { msisdn: this.activationRequest.msisdn, password: this.activationRequest.password });
      this.$router.push({name: 'login'});
    },

    processErrorCallResponse: function(callData) {
      if(callData.response === undefined || callData.response.data === undefined) {
        this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
        this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'KUZO registration',label: 'Error - no data', value: 0, noninteraction: false });
        return;
      }

      let responseCode = callData.response.data.responseCode;

      switch(responseCode) {
        case VALIDATION_ERROR:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.VALIDATION_ERROR'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'KUZO registration',label: 'Error - validation error', value: 0, noninteraction: false });
          break;
        case TEMPORARILY_LOCKED:
          this.$store.commit("setErrorMessage", this.$i18n.t('KUZO_REGISTRATION.ERROR_MESSAGES.TEMPORARILY_LOCKED'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'KUZO registration',label: 'Error - temporarily locked', value: 0, noninteraction: false });
          break;
        case PUK_INCORRECT:
          this.$store.commit("setErrorMessage", this.$i18n.t('KUZO_REGISTRATION.ERROR_MESSAGES.PUK_INCORRECT'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'KUZO registration',label: 'Error - PUK incorrect', value: 0, noninteraction: false });
          break;
        case ACTIVATION_NOT_POSSIBLE:
          this.$store.commit("setErrorMessage", this.$i18n.t('KUZO_REGISTRATION.ERROR_MESSAGES.ACTIVATION_NOT_POSSIBLE'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'KUZO registration',label: 'Error - activation not possible', value: 0, noninteraction: false });
          break;
        case SIM_INACTIVE:
          this.$store.commit("setErrorMessage", this.$i18n.t('KUZO_REGISTRATION.ERROR_MESSAGES.SIM_INACTIVE'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'KUZO registration',label: 'Error - USIM inactive', value: 0, noninteraction: false });
          break;
        case VOUCHER_NOT_USEABLE:
          this.$store.commit("setErrorMessage", this.$i18n.t('KUZO_REGISTRATION.ERROR_MESSAGES.VOUCHER_NOT_USEABLE'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'KUZO registration',label: 'Error - voucher not useable', value: 0, noninteraction: false });
          break;
        case VOUCHER_USE_LOCKED:
          this.$store.commit("setVoucherAllowed", false);
          this.$store.commit("setErrorMessage", this.$i18n.t('KUZO_REGISTRATION.ERROR_MESSAGES.VOUCHER_USE_LOCKED'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'KUZO registration',label: 'Error - voucher use locked', value: 0, noninteraction: false });
          break;
        case OTHER_ERROR:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'KUZO registration',label: 'Error - technical error', value: 0, noninteraction: false });
          break;
        default:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'KUZO registration',label: 'Error - '+responseCode, value: 0, noninteraction: false });
      }
      },
  },
};
</script>

<style lang="scss" src="@/components/loading/loading.scss">
</style>
